module.exports = __webpack_public_path__ + "static/media/LK_Close_Dark.c3edb205.svg";